import { EmployeeServices } from '@appinternal/karyawan-api-services';

import { ComponentDefaultPropsConfig } from 'lib/plugins/WangsVue';
import { genPlaceholder } from 'lib/utils/genPlaceholder.util';

import { getImageURL, getStatusSeverity } from '../utils';

const defaultProps: ComponentDefaultPropsConfig = {
  ButtonBulkAction: {
    naming: 'data',
  },
  Image: {
    getImageURL,
    placeholder: genPlaceholder('WS', 125).toDataURL(),
  },

  Dropdown: {
    allowNullOption: true,
  },

  UserName: {
    async getUserDetail(userId) {
      const { data } = await EmployeeServices.getEmployeeDetail(userId);
      return {
        ...data.data,
        position: data.data.position.name,
        division: data.data.division.name,
      };
    },
    detailUserPath: '/karyawan/semua',
    formatUserName: false,
    type: 'picture',
    profilePictureField: 'profilePicture',
    userNameField: 'fullName',
  },

  Badge: {
    getSeverity: getStatusSeverity,
  },
};

export default defaultProps;
